<template>
  <div class="stock-out">
    <!-- tab -->
    <ContentHeader
      path-set-type="append"
      :path-info="navPathInfo"
      :show-back="true"
    />

    <div class="content-container">
      <!-- 查询条件 -->
      <div class="query-panel">
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="出库单编号">
                <el-input
                  v-model="queryParam.billNumber"
                  placeholder="请输入出库单编号"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseIds"
                  placeholder="请选择仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出库单状态">
                <el-select
                  v-model="queryParam.billStatus"
                  placeholder="请选择出库单状态"
                  clearable
                >
                  <el-option
                    v-for="option in stockStatusList"
                    :key="option.key"
                    :label="option.value"
                    :value="option.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="查询日期">
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.fromDate"
                    type="date"
                    placeholder="开始日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="startTimeStatus"
                    :picker-options="pickerOptionsStart"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="queryParam.toDate"
                    type="date"
                    placeholder="截止日期"
                    value-format="yyyy-MM-dd"
                    class="form-date-item"
                    @change="endTimeStatus"
                    :picker-options="pickerOptionsEnd"
                  />
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>

      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table
          :data="stockOrderList"
          class="while-data-table"
          v-loading="loading"
        >
          <el-table-column prop="billNumber" label="单号"></el-table-column>
          <el-table-column
            prop="warehouseName"
            label="出库仓库"
          ></el-table-column>
          <el-table-column label="出库时间">
            <template slot-scope="scope">
              {{ scope.row.stockOutTime | parseTime("{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column prop="billStatusName" label="状态"></el-table-column>
          <el-table-column
            prop="billRemark"
            label="备注"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="240"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleShow(scope.row)"
                  >查看</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  v-if="scope.row.billStatus === 100"
                  @click="handleCancle(scope.row)"
                  >取消</el-button
                >
                <!-- <el-button
                  type="danger"
                  size="mini"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                > -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContentHeader from '@/components/content-header'
export default {
  name: 'stock-out',
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        billId: '',
        billNumber: '',
        itemCode: '',
        itemName: '',
        billStatus: '',
        warehouseIds: '',
        fromDate: '',
        toDate: ''
      },
      total: 0,
      stockOrderList: [],
      stockOrder: {},
      warehouseList: [],
      pickerOptionsStart: {},
      pickerOptionsEnd: {}
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = { path: '/stock/stock', name: '库存' }
      return [pathInfo]
    },
    ...mapState({
      stockStatusList: state => state.base.stockOrderStatusMap
    })
  },
  activated () {
    this.getStockOrderList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'stockOrderStatusMap')
      this.getWarehouseList()
      this.getStockOrderList()
    },
    // 获取出库管理列表
    getStockOrderList () {
      this.loading = true
      this.$store
        .dispatch('queryStockOrderList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockOrderList = res.data.resultData.stockOrderList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 查看详情
    handleShow (row) {
      this.$router.push({
        path: '/stock/stock-out/info',
        query: { billId: row.billId }
      })
    },

    // 取消
    handleCancle (row) {
      this.$confirm('是否确认取消该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('cancleStockOrder', { billId: row.billId })
            .then(res => {
              if (res.data.resultCode === '0') {
                this.getStockOrderList()
                this.$message.success('订单关闭成功')
              }
            })
            .catch(() => {
              this.$message.error('订单关闭失败')
            })
        })
        .catch(() => {})
    },

    // 删除
    handleDelete (row) {
      this.$confirm('是否确认删除该订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('deleteStockOrder', { billId: row.billId })
            .then(res => {
              if (res.data.resultCode === '0') {
                this.getStockOrderList()
                this.$message.success('订单删除成功')
              }
            })
            .catch(() => {
              this.$message.error('订单删除失败')
            })
        })
        .catch(() => {})
    },

    // 查询
    searchQuery () {
      this.queryParam.page = 1
      this.getStockOrderList()
    },

    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseLists').then(res => {
        this.warehouseList = res.data.resultData.warehouseList
      })
    },

    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getStockOrderList()
    },
    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getStockOrderList()
    },
    // 时间开始选择器
    startTimeStatus: function (value) {
      this.pickerOptionsEnd = {
        disabledDate: time => {
          let beginDateVal = this.queryParam.fromDate
          if (beginDateVal) {
            return (
              time.getTime() <= new Date(beginDateVal).getTime() - 86400000
            )
          }
        }
      }
    },
    // 时间结束选择器
    endTimeStatus: function (value) {
      this.pickerOptionsStart = {
        disabledDate: time => {
          let endDateVal = this.queryParam.toDate
          if (endDateVal) {
            return time.getTime() >= new Date(endDateVal).getTime()
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
